const gConstants = window.__GENERATED_CONSTANTS__.UserListConfirmationConstants
export const UserListConfirmationConstants = {
    LAST_APPROVER_DISABLED: gConstants.LAST_APPROVER_DISABLED,
    LAST_APPROVER_RIGHT_REVOKED: gConstants.LAST_APPROVER_RIGHT_REVOKED,
    LAST_OTHER_PRODUCT_APPROVER_DISABLED: gConstants.LAST_OTHER_PRODUCT_APPROVER_DISABLED,
    LAST_APPROVER_DELETED: gConstants.LAST_APPROVER_DELETED,
    LAST_OTHER_PRODUCT_APPROVER_DELETED: gConstants.LAST_OTHER_PRODUCT_APPROVER_DELETED,
    HAS_LEAVE_REQUESTS: gConstants.HAS_LEAVE_REQUESTS
}

export default UserListConfirmationConstants



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/UserListConfirmationConstants.js